import React from 'react';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.warn('**** ERROR FROM BWL ERROR BOUNDARY****');
    console.error(error, errorInfo);
    console.warn('*****************');
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div>There was an error rendering. Check developer console for more info.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary